/* eslint-disable react-hooks/exhaustive-deps */

import React from "react"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { Button, Col, Row, Card } from "react-bootstrap"
import { useDispatch } from "react-redux"
import {
  ModalOuter,
  TModalTypes,
} from "../../../../components/Modal/ModalOuter"
import InvoiceListService from "../../../../service/billing/invoice/invoiceListService"
import {
  TInvoiceKoteiSeikyuListGetReq,
  TInvoiceKoteiSeikyuListGetRes,
  TInvoiceKoteiSeikyuListPutReq,
  TInvoiceKoteiSeikyuInfo,
} from "../../../../service/billing/invoice/TInvoice"
import { TApiResponse } from "../../../../service/TApiResponse"

// Kairos
import { AppDispatch } from "../../../.."
import FlexGridOuter from "../../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../../components/Spinner"
import gridPageHelper from "../../../../ts/helpers/gridPageHelper"
import CONST from "../../../../constant"
import { showInfoToast } from "../../../../components/CustomToast"
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import { 画面ロック解除 } from "../../../../globalStore/progressStore"
import { clearAlert, setAlerts } from "../../../../globalStore/alertStore"

// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

export type T固定請求明細GridItem = TInvoiceKoteiSeikyuListGetRes

const InvoiceListKoteiSeikyuModal: React.FC<
  TModalTypes & {
    請求伝票番号?: string
    請求年月?: string
    isUpdateKoteiSeikyu: boolean
    setIsUpdateKoteiSeikyu: (value: boolean) => unknown
    固定請求額差分: number
    set固定請求額差分: (value: number) => unknown
    請求合計更新日時?: string | null
    set請求合計更新日時: (value: string | null) => unknown
  }
> = (props) => {
  const location = useLocation()

  //TODO:ページ名称確定必須
  let gridId = "InvoiceListKoteiSeikyuModal_GridId"

  //#region [baseMethod]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)
  const [searchResult, setSearchResult] = useState<T固定請求明細GridItem[]>()

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  // 更新処理用
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //#endregion

  //#region [effect]
  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (props.isShow) {
      //初回filter作成時は常に検索を行う
      // 検索
      search().finally(() => {
        dispatch(画面ロック解除())
      })

      if (location.search !== "") {
        // リストア中フラグON
        setIsRestoreSearching(true)
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [props.isShow])

  useEffect(() => {
    if (searchResult == null) return

    flexGrid?.refresh()
    setGridData({ data: createCollectionView(searchResult, pageSize) })
  }, [searchResult])

  //#endregion

  //#region [method]
  /**
   * 検索
   */
  const search = async (searchCondition?: TInvoiceKoteiSeikyuListGetReq) => {
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TInvoiceKoteiSeikyuListGetReq | undefined
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    if (currentSearchCondition == null) return

    try {
      const service = new InvoiceListService()

      const res = await service.getKoteiSeikyuList(currentSearchCondition)
      setSearchResult([...res.data])
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false)
    }
  }

  /**
   * 検索条件作成
   * @param queryString
   */
  const createSearchCondition = (
    queryString?: string
  ): TInvoiceKoteiSeikyuListGetReq => {
    return {
      請求伝票番号: props.請求伝票番号,
    }
  }

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装

    setIsConfirmModalShow(true)
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認

      const koteiSeikyuInfo: TInvoiceKoteiSeikyuInfo[] = []
      let seikyuGoukeiModifiedDt: string = ""
      let seikyuDenpyoNo: string = ""

      flexGrid?.collectionView.sourceCollection.forEach(
        (row: TInvoiceKoteiSeikyuListGetRes) => {
          let koteiSeikyuRow: TInvoiceKoteiSeikyuInfo = {
            請求内訳ID: row.請求内訳ID,
            課税区分: row.課税区分コード,
            消費税計算区分: row.消費税計算区分コード,
            金額: row.金額,
            備考: row.備考,
            請求内訳更新日時: row.請求内訳更新日時,
          }
          koteiSeikyuInfo.push(koteiSeikyuRow)

          seikyuGoukeiModifiedDt = row.請求合計更新日時
          seikyuDenpyoNo = row.請求伝票番号
        }
      )

      const data: TInvoiceKoteiSeikyuListPutReq = {
        固定請求明細情報リスト: koteiSeikyuInfo,
        請求合計更新日時: seikyuGoukeiModifiedDt,
        請求伝票番号: seikyuDenpyoNo,
        請求年月: props.請求年月,
      }

      const service = new InvoiceListService()

      let res: TApiResponse<TInvoiceKoteiSeikyuListGetRes[]>
      res = await service.putKoteiSeikyu(0, data)
      dispatch(setAlerts(res))
      if (res) {
        props.set固定請求額差分(res.data[0].金額)
        props.set請求合計更新日時(res.data[0].請求合計更新日時)
        showInfoToast(`月固定請求明細の更新が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
      props.setIsShow(false)
      props.setIsUpdateKoteiSeikyu(true)
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // handler付与
    grid.formatItem.addHandler(formatItem)
    grid.beginningEdit.addHandler(beginningEdit)
    grid.cellEditEnding.addHandler(cellEditEnding)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      let col = f.columns[e.col]
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        switch (col.binding as keyof TInvoiceKoteiSeikyuListGetRes) {
          case "金額":
            // 請求締め処理の時点で固定請求金額が設定済の場合はreadonly
            // 荷主請求内訳の固定請求額が0以外の場合自由入力
            if (e.getRow().dataItem.固定請求額 > 0) {
              wjCore.toggleClass(e.cell, "read-only-cell", true)
              return
            }
            break
          default:
            break
        }
      }
    }
  }

  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  const beginningEdit = (s: wjGrid.FlexGrid, e: wjGrid.CellRangeEventArgs) => {
    if (e.panel === s.cells) {
      const cellBinding = e.getColumn().binding
      let col = s.columns[e.col]
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        switch (col.binding as keyof TInvoiceKoteiSeikyuListGetRes) {
          case "金額":
            // 請求締め処理の時点で固定請求金額が設定済の場合は入力不可
            // 固定請求額が0以上のとき入力不可
            if (e.getRow().dataItem.固定請求額 > 0) {
              e.cancel = true
              return
            }
            break
          default:
            break
        }
      }
    }
  }

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = (s: wjGrid.FlexGrid, e: wjGrid.CellRangeEventArgs) => {}

  const cellEditEnding = (
    s: wjGrid.FlexGrid,
    e: wjGrid.CellEditEndingEventArgs
  ) => {
    // キャンセルの場合処理しない

    if (e.cancel) return
  }

  //#endregion

  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title}
      setIsShow={props.setIsShow}
      size={props.size}
      footer={
        <>
          <Button
            type="submit"
            variant="waiting"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              beforeSubmit()
            }}>
            更新
          </Button>
        </>
      }>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                isShowGridRowPickupButton={false}
                isShowGridFooter={true}
                isEnablePageSize={"visible"}
                isEnableExport={false}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                gridProperties={{
                  frozenColumns: 1,
                  isReadOnly: false,
                  allowMerging: wjGrid.AllowMerging.ColumnHeaders,
                  headersVisibility: wjGrid.HeadersVisibility.All,
                  keyActionTab: wjGrid.KeyAction.CycleOut,
                  cellEditEnded,
                }}>
                <wjrGrid.FlexGridColumn
                  binding="請求内訳名"
                  width={220}
                  isReadOnly={true}
                  cssClassAll={"read-only-cell"}
                  header="請求内訳"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車番"
                  width={100}
                  isReadOnly={true}
                  cssClassAll={"read-only-cell"}
                  header="定額車番"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="課税区分正式名称"
                  width={90}
                  isReadOnly={true}
                  cssClassAll={"read-only-cell"}
                  header="税区分"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額"
                  width={100}
                  cssClass="number-col"
                  dataType={wjCore.DataType.Number}
                  header="金額"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="修正前金額"
                  width={100}
                  cssClass="number-col"
                  visible={false}
                  header="修正前金額"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備考"
                  width={200}
                  header="備考"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <ConfirmModal
          isShow={isConfirmModalShow}
          hideHandler={setIsConfirmModalShow}
          submitHandler={submit}>
          入力された内容で更新しますか？
        </ConfirmModal>
      </Row>
    </ModalOuter>
  )
}

export default InvoiceListKoteiSeikyuModal
